import { collection, getDocs, doc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "../Firebase";

export const getProducts = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "generator_products"));
    const list = [];
    querySnapshot.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });
    return list;
  } catch (error) {
    console.error("Error fetching products from Firestore: ", error);
    throw error;
  }
};

export const saveProduct = async (product) => {
  try {
    const docRef = doc(db, "generator_products", product.id);
    await setDoc(docRef, product, { merge: true });
  } catch (error) {
    console.error("Error saving product to Firestore: ", error);
    throw error;
  }
};

export const deleteProductDoc = async (id) => {
  try {
    const docRef = doc(db, "generator_products", id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Error deleting product from Firestore: ", error);
    throw error;
  }
};
